import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonModule } from '../button/button.module';
import { IconModule } from '../icon/icon.module';
import { FormModule } from '../form/form.module';
import { TableEditableComponent } from './table-editable/table-editable.component';
import { EditableDetailsIconComponent } from './table-editable/editable-details-icon/editable-details-icon.component';


@NgModule({
  imports: [CommonModule, ButtonModule, IconModule, FormModule],
  declarations: [
    TableEditableComponent,
    EditableDetailsIconComponent,
  ],
  exports: [
    TableEditableComponent,
    EditableDetailsIconComponent,
   ],
  providers: []
})
export class TableModule { }
